import { Setter } from "../services/ComService"
import { GLItemDTO, GLItemKind, GLItemStatus, IGLItem } from "./GLItemDTO"

export interface GLItemRequest {
    id?: number
    page?: number
    limit?: number
    personId?: number
    customerId?: number
    needle?: string
    kind?: GLItemKind
    status?: GLItemStatus
}
export class GLItemsDTO {
    request: GLItemRequest
    items: GLItemDTO[] = []
    allowInfinitScroll: boolean = true
    total: number = 0

    constructor(data: GLItemRequest) {
        this.request = data
    }

    patchRequest(data: GLItemRequest) {
        this.request = {...this.request, ...data}
    }

    async getFromServer(data?: GLItemRequest) {
        this.allowInfinitScroll = false
        if(data) this.patchRequest(data)
        const result = await Setter('spt/gl_items/search', this.request)
        const newItems = result.data.map((item: any) => new GLItemDTO(item))
        this.total = result.total
        if (newItems.length === 0) {
            return
        }
        this.allowInfinitScroll = true
        if (this.request.page === 1) {
            this.items = newItems
        } else {
            this.items = [...this.items, ...newItems]
        }
    }

    async getNextPage() {
        if (!this.allowInfinitScroll) { return }
        await this.getFromServer({page: (this.request.page || 1) + 1})
    }

    async getFresh() {
        this.items = []
        this.allowInfinitScroll = true
        await this.getFromServer({page: 1})
    }

    async setNeedle(needle: string) {
        this.items = []
        this.request.needle = needle
        await this.getFresh()
    }

    async createNew(data: IGLItem) {
        const newItem = new GLItemDTO(data)
        await newItem.save()
        await this.getFresh()
    }

    async deleteItem(id: number) {
        const item = this.items.find(i => i.id === id)
        if(item) {
            await item.delete()
            await this.getFresh()
        }
    }

    get() {
        let out: GLItemDTO[] = []
        if (this.request.id && this.request.id > -1) {
            // Detail view - do not show main item, only children:
            this.items.forEach(item => {
                if (item.children) {
                    for (let i = item.children.length -1; i >= 0; i--) {
                        const c = item.children[i]
                        out.push(c)
                    }
                }
            })
        } else {
            out = this.items
        }
        return out
    }

    getHeadlineDetails() {
        const item = this.items[0]
        if (!item) { return {
            headline: '',
            personName: '',
            customerName: '',
        } }
        return {
            headline: item.headline,
            personName: `${item.person?.firstname || ''} ${item.person?.lastname || ''}`,
            customerName: `${item.person?.customerName || ''}`,
        }
    }

    getHeadline1() {
        const details = this.getHeadlineDetails()
        return details.headline
    }

    getHeadline2() {
        const details = this.getHeadlineDetails()
        if (details.personName && details.customerName) {
            return `${details.personName} (${details.customerName})`
        }
    }
}
